import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { authToken } from '../storage/authToken';
import { ToastContainer } from 'react-toastify';
import { useAuthSelector } from '../services/selectors/authSelector';

import * as Auth from '../auth';
import * as Pages from '../pages';
import * as routeNames from './routeName';
import ProtectedRoute from './protectedRoute';

const AppRoutes = () => {
	
	const token = authToken();
	const { pharmacyId } = useAuthSelector();

	return (
		<>
			<Routes>
				{/* Public route */}
				<Route path={routeNames.HOME_ROUTE} element={!token ? <Auth.SignIn /> : <Navigate to={routeNames.DASHBOARD_PHARMACY} replace />} />

				{/* Protected routes */}
				<Route element={<ProtectedRoute isAllowed={!!token && !!pharmacyId} redirectPath={routeNames.HOME_ROUTE} />}>

					<Route path={routeNames.DASHBOARD_PHARMACY} element={<Pages.DriverDashboard />} />
					<Route path={routeNames.SELECT_DEFAULT_PHARMACIST} element={<Pages.SelectDefaultPharmacist />} />
					<Route path={routeNames.DRIVER_ROUTE_TODAY} element={<Pages.TodayDispense />} />
					<Route path={routeNames.PHARMACY_FRONT_PROFILE} element={<Pages.PharmacyFrontProfile />} />
					<Route path={routeNames.DRIVER_PASSWORD} element={<Pages.ChangePassword />} />

					<Route path={routeNames.MY_PROFILE} element={<Pages.MyProfile />} />
					<Route path={routeNames.DRIVER_PASSCODE} element={<Pages.UpdatePasscode />} />
					<Route path={routeNames.Patient_Consent} element={<Pages.PatientConsent />} />
					<Route path={routeNames.DRIVER_ROUTE_DELIVERED} element={<Pages.DeliveredPatient />} />

					<Route path={routeNames.driver_today_pending} element={<Pages.PendingDispense />} />
					<Route path={routeNames.search_patient_data} element={<Pages.SearchPatientList />} />
					<Route path={routeNames.upload_prescripition} element={<Pages.UploadPrescripition />} />

					<Route path={routeNames.pending_pharmacist_signatures} element={<Pages.PendingPharmacistSignatures />} />
					<Route path={routeNames.pending_all_pharmacist_signatures} element={<Pages.PendingAllPharmacistSignsList />} />
					<Route path={routeNames.pending_counselling} element={<Pages.PendingCounselling />} />
					<Route path={routeNames.flexi_delivery} element={<Pages.FlexiDelivery />} />
					<Route path={routeNames.red_bag} element={<Pages.RedBag />} />
				</Route>

				{/* Catch-all route */}
				<Route path="*" element={<Navigate to={token && pharmacyId ? routeNames.DASHBOARD_PHARMACY : routeNames.HOME_ROUTE} replace />} />
			</Routes>
			<ToastContainer />
		</>
	);
};

export default AppRoutes;
